<div class="company-assesstment-container">
    <router-outlet></router-outlet>
    <!-- <app-assessment-dashboard *ngIf="showDashboard==true" (selectedCompanyAssessment)="continuewithCompAss($event)" (goToCalculations)="goToCalculations($event)"></app-assessment-dashboard>
    <app-calculation-stepper *ngIf="showDashboard==false" [currentCompanyAssessment]="selectedCompAss" (goToDashboard)="goToCalculations($event)"></app-calculation-stepper> -->

</div>
